module.exports = __webpack_public_path__ + "static/Logo_4-0a61fe718f4717ef739bd51fc266fe30.png";